// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results_card-module__searchCard--1Fk-H{border:1px solid #c6ced5;background-color:#fff;border-radius:4px;padding:24px 24px 0;margin-bottom:40px;display:inline-block;width:100%}.results_card-module__title--2LcSz{margin-bottom:8px}.results_card-module__followContainer--24KJf{margin-top:16px;margin-bottom:16px}.results_card-module__footer--3esZw{display:inline-block;width:100%;padding:8px 0px;border-top:1px solid #c6ced5}.results_card-module__list--2LrQn{padding-top:8px}\n", ""]);
// Exports
exports.locals = {
	"searchCard": "results_card-module__searchCard--1Fk-H",
	"title": "results_card-module__title--2LcSz",
	"followContainer": "results_card-module__followContainer--24KJf",
	"footer": "results_card-module__footer--3esZw",
	"list": "results_card-module__list--2LrQn"
};
module.exports = exports;
